// import app from '@/main'
import { send } from '@/plugins/send.js'

async function authSendLoginLink (email) {
  return await send({
    data: {
      email: email
    },
    method: 'auth.sendLoginLink'
  })
}

export default authSendLoginLink
